module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class,
    on: {
      "mouseenter": function($event) {
        _vm.is_hover = true
      },
      "mouseleave": function($event) {
        _vm.is_hover = false
      }
    }
  }, [_c('div', {
    ref: "swiper_container",
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.index) ? _c('SwipeIndex', {
    attrs: {
      "swiper": _vm.swiper,
      "slides_len": _vm.slides_len,
      "index_trigger": _vm.index_trigger,
      "index_x_offset": _vm.index_x_offset,
      "index_y_offset": _vm.index_y_offset
    },
    on: {
      "active": function($event) {
        _vm.slideTo(arguments[0]), _vm.swiper.startAutoplay()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.arrow && _vm.swiper) ? _c('SwipeArrow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrow !== 'hover' || _vm.is_hover),
      expression: "arrow !== 'hover' || is_hover"
    }],
    attrs: {
      "swiper": _vm.swiper,
      "outer_arrow": _vm.outer_arrow,
      "loop": _vm.loop,
      "preview": _vm.preview,
      "arrow_offset": _vm.arrow_offset,
      "slides_len": _vm.slides_len
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f54eae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swipe/Swipe.vue
// module id = 669
// module chunks = 0